<template>
  <div id="app">
    <router-view/>
    <Notifier />
    <Loader />
  </div>
</template>

<script>
import Loader from '@/components/loader'
import Notifier from '@/components/notifier'

export default {
  name: 'App',
  components: {
    Loader,
    Notifier
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.tooltip {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: rgba(33, 37, 41, .9);
  border-radius: 4px;
  font-size: 1.2rem;
  color: #FFF;
  padding: .5em 1em;
  font-weight: normal;
  z-index: 10;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgba(33, 37, 41, .9);
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
</style>
